/**
 * CSV export (ADR 0018): UTF-8 with BOM (Excel detects the encoding), CRLF rows, a header row.
 * Separator ";" for Turkish Excel (decimal comma) or "," (decimal point). Built in chunks so a large
 * export never blocks the page for long.
 */
import { cellText, isSystemText, yieldNow, type ExportMeta, type Sheet } from "./sheet";

export const BOM = "﻿";

/**
 * Quote when needed. Text that a spreadsheet would run as a formula (=, +, -, @, tab, CR at the start)
 * gets a leading apostrophe ("CSV injection"); numbers and FTS's own texts (SystemText) are never touched.
 */
export function csvCell(text: string, separator: string, isText: boolean): string {
  let v = text;
  if (isText && /^[=+\-@\t\r]/.test(v)) v = `'${v}`;
  return v.includes(separator) || /["\r\n]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v;
}

/** One sheet as CSV text (with BOM). Multi-sheet jobs export the first sheet (the report's main table). */
export async function buildCsv(sheet: Sheet, meta: Pick<ExportMeta, "tz" | "locale" | "labels">, separator: "," | ";" = ",", chunk = 5000): Promise<string> {
  const decimalComma = separator === ";";
  const out: string[] = [sheet.columns.map((c) => csvCell(c.header, separator, true)).join(separator)];
  for (let i = 0; i < sheet.rows.length; i++) {
    const row = sheet.rows[i]!;
    out.push(sheet.columns.map((c, j) => csvCell(cellText(row[j] ?? null, c.type, meta, decimalComma), separator, c.type === "text" && !isSystemText(row[j]))).join(separator));
    if (chunk > 0 && i > 0 && i % chunk === 0) await yieldNow();
  }
  return BOM + out.join("\r\n") + "\r\n";
}
